import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";
import { AppLoader } from "../../Components/common/AppLoader/AppLoader";
import { fetchEstablishmentById, fetchAccreditations, getEstablishmentIdFromSlug } from "../../api/hospitalApi";
import { mapEstablishmentToProfile } from "../../utils/hospitalHelpers";
import HospitalProfileView from "./HospitalProfileView";
import "./hospital-profiles.css";

export const HospitalProfilePage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [hospital, setHospital] = useState(null);
  const [accreditations, setAccreditations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError("");

      const establishmentId = getEstablishmentIdFromSlug(slug);
      if (!establishmentId) {
        setHospital(null);
        setError("Hospital profile not found.");
        setLoading(false);
        return;
      }

      try {
        const [est, accr] = await Promise.all([
          fetchEstablishmentById(establishmentId),
          fetchAccreditations(),
        ]);

        if (cancelled) return;
        setAccreditations(accr);
        const mapped = mapEstablishmentToProfile(est, { accreditations: accr });
        setHospital(mapped);

        if (mapped.slug && mapped.slug !== slug) {
          navigate(`/hospitals/${mapped.slug}`, { replace: true });
        }
      } catch (err) {
        if (!cancelled) {
          setHospital(null);
          setError(err.message || "Hospital profile not found.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [slug, navigate]);

  if (loading) {
    return (
      <div className="hp-profile-page hp-profile-page--empty">
        <Container className="text-center py-5">
          <AppLoader variant="page" />
        </Container>
      </div>
    );
  }

  if (error || !hospital) {
    return (
      <div className="hp-profile-page hp-profile-page--empty">
        <Container>
          <p>{error || "Hospital profile not found."}</p>
          <Button onClick={() => navigate("/hospitals")}>Back to Hospitals</Button>
        </Container>
      </div>
    );
  }

  return (
    <section className="hp-profile-page">
      <Container fluid className="hp-profile-page__container">
        <HospitalProfileView hospital={hospital} accreditations={accreditations} />
      </Container>
    </section>
  );
};
